import React from 'react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {useFallbackRef} from "../../../infrastructure/hooks/useFallbackRef";

export class BaseImageProps extends BaseProps {
  src: String;
  alt: String;
  className: String;
  ref;
  width: Number;
  height: Number;
}

export const BaseImage = React.forwardRef((props: BaseImageProps, forwardedRef) => {
  const ref = useFallbackRef(forwardedRef)

  const imgProps = {
    ...props,
    ref
  };

  return <img {...imgProps} alt={props.alt}/>;
});
